import { isEmpty } from "lodash";
import { IAbsenceRequestHistoryEntryDetails } from "src/Pages/Company/Absences/AbsenceRequest/AbsenceRequest.models";
import {
  AbsenceTypeHistoryEntryDetailsTypes,
  IAbsenceTypeHistoryItemDetails,
} from "src/Pages/Company/Absences/AbsenceType/AbsenceType.models";

export default (
  details: IAbsenceRequestHistoryEntryDetails | IAbsenceTypeHistoryItemDetails
) => {
  if (!details || isEmpty(details)) return [];

  const rows: any[] = [];

  Object.entries(details).forEach(([key, value]) => {
    if (value === null) return;

    // Special handling for CONFIGURATION_OPTIONS
    if (key === AbsenceTypeHistoryEntryDetailsTypes.CONFIGURATION_OPTIONS) {
      const configOptions = value;

      // configKeys whose value is a nested { enabled: {before, after}, required: {before, after} }
      // object rather than a flat { before, after } pair.
      const subOptionConfigKeys = [
        "attachmentConfiguration",
        "replacerConfiguration",
      ];
      // Legacy derived boolean fields superseded by the *Configuration keys above.
      const legacyConfigKeys = ["attachmentRequired", "replacerRequired"];

      Object.entries(configOptions).forEach(
        ([configKey, configValue]: [string, any]) => {
          if (!configValue) return;

          if (legacyConfigKeys.includes(configKey)) {
            return;
          }

          if (configKey === "submitLimitations") {
            // Handle submitLimitations separately - create rows for prior and advance
            Object.entries(configValue).forEach(
              ([limitationType, limitationValue]: [string, any]) => {
                if (
                  limitationValue &&
                  limitationValue.before !== undefined &&
                  limitationValue.after !== undefined
                ) {
                  rows.push({
                    id: `${key}.${configKey}.${limitationType}`,
                    parentId: key,
                    configKey: "submitLimitations",
                    submitLimitationType: limitationType, // "prior" or "advance"
                    before: limitationValue.before,
                    after: limitationValue.after,
                  });
                }
              }
            );
          } else if (subOptionConfigKeys.includes(configKey)) {
            // Handle *Configuration separately - create rows for enabled and required
            Object.entries(configValue).forEach(
              ([subKey, subValue]: [string, any]) => {
                if (
                  subValue &&
                  subValue.before !== undefined &&
                  subValue.after !== undefined
                ) {
                  rows.push({
                    id: `${key}.${configKey}.${subKey}`,
                    parentId: key,
                    configKey: `${configKey}.${subKey}`,
                    before: subValue.before,
                    after: subValue.after,
                  });
                }
              }
            );
          } else {
            rows.push({
              id: `${key}.${configKey}`,
              parentId: key,
              configKey,
              before: configValue.before,
              after: configValue.after,
            });
          }
        }
      );
    }
    // Special handling for NOTIFICATIONS_CONFIGURATION
    else if (
      key === AbsenceTypeHistoryEntryDetailsTypes.NOTIFICATIONS_CONFIGURATION
    ) {
      const notificationConfig = value as any;

      Object.entries(notificationConfig).forEach(
        ([groupKey, groupValue]: [string, any]) => {
          if (groupValue && typeof groupValue === "object") {
            Object.entries(groupValue).forEach(
              ([notificationKey, notificationValue]: [string, any]) => {
                if (
                  notificationValue &&
                  notificationValue.before !== undefined &&
                  notificationValue.after !== undefined
                ) {
                  rows.push({
                    id: `${key}.${groupKey}.${notificationKey}`,
                    parentId: key,
                    groupKey,
                    notificationKey,
                    before: notificationValue.before,
                    after: notificationValue.after,
                  });
                }
              }
            );
          }
        }
      );
    } else {
      // Regular handling for other fields
      rows.push({
        id: key,
        ...value,
      });
    }
  });

  return rows;
};
